import { useEffect } from 'react';

const DEFAULT_TITLE = 'UK Pension vs Index Fund Calculator | Free Retirement Planning Tool';
const DEFAULT_DESCRIPTION =
  'Compare UK pension schemes against Stocks & Shares ISA index fund investing. Calculate compound growth, tax relief, employer contributions and retirement income. Free tool for UK investors.';

export const usePageMeta = (title: string, description: string) => {
  useEffect(() => {
    document.title = title;

    const metaDesc = document.querySelector('meta[name="description"]');
    if (metaDesc) metaDesc.setAttribute('content', description);

    const ogTitle = document.querySelector('meta[property="og:title"]');
    if (ogTitle) ogTitle.setAttribute('content', title);

    const ogDesc = document.querySelector('meta[property="og:description"]');
    if (ogDesc) ogDesc.setAttribute('content', description);

    return () => {
      document.title = DEFAULT_TITLE;
      if (metaDesc) metaDesc.setAttribute('content', DEFAULT_DESCRIPTION);
      if (ogTitle) ogTitle.setAttribute('content', DEFAULT_TITLE);
      if (ogDesc) ogDesc.setAttribute('content', DEFAULT_DESCRIPTION);
    };
  }, [title, description]);
};
